/* eslint-disable new-cap */
import { axisData } from './axis.data';
import { ControllerRootOptions } from '../../controller-classes';
import { degrees2radians } from '../functions';
import { AxisDataIn, AxisDataOut } from './types';
import { correctAngle, rotateCfn } from './functions';

export class Axis {
	public angleCorrection: boolean;
	#x: number;
	#y: number;
	#z: number;

	constructor (options: ControllerRootOptions<AxisDataIn> = {}) {
		// super(BlueprintInstanceType.Axis, options);

		this.angleCorrection = true;

		const { dataIn = null } = options;
		const data = axisData(dataIn);

		this.#x = data.x;
		this.#y = data.y;
		this.#z = data.z;

		// console.log('new Axis', this.#y)
	}

	get xr (): number { return degrees2radians(this.#x) }
	get x (): number { return this.angleCorrection ? correctAngle(this.#x) : this.#x }
	set x (v: number) { this.#x = v }

	get yr (): number { return degrees2radians(this.#y) }
	get y (): number {
		return this.angleCorrection ? correctAngle(this.#y) : this.#y;
	}
	set y (v: number) {
		this.#y = v
	}

	get zr (): number { return degrees2radians(this.#z) }
	get z (): number { return this.angleCorrection ? correctAngle(this.#z) : this.#z }
	set z (v: number) { this.#z = v }

	public serialize (): AxisDataOut {
		return {
			x: this.#x,
			y: this.#y,
			z: this.#z
		};
	}

	public rotate (axis: Axis): Axis { return rotateCfn(this, axis); }
	public clone (): Axis { return new Axis({ dataIn: this.serialize() }); }
}
